import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
            影视索引
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8">按分类快速找到你想看的影视内容</p>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#index"
                className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
              >
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600 group-hover:text-primary-700 transition-colors mb-1">
                  {item.count}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}